export const getConfigurationTypeId = data => data?.configurationType?.id;
